import api from './api';

export default {
  getQueues() {
    return new Promise((resolve, reject) => {
      api
        .get('dialler/queues')
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getQueueForUser(queueId, userId) {
    return new Promise((resolve, reject) => {
      api
        .get(`dialler/queues/${queueId}/${userId}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getDeviceToken() {
    return new Promise((resolve, reject) => {
      api
        .get('dialler/token')
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  getPhoneCallOutcomes() {
    return new Promise((resolve, reject) => {
      api
        .get('phone-call-outcome', { params: { orderby: 'name,asc', filters: { where: [['enabled', '=', true]] } } })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },

  updatePhoneCallRecord(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`phone-call/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  schedulePhoneCall(id, time) {
    return new Promise((resolve, reject) => {
      api
        .post('phone-call', { id, time })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
